import { useQuery } from 'react-query';
import {
  getPayLetterAvailablePaymentMethods,
  type GetPayLetterAvailablePaymentMethodsResponse
} from '../../services/paymentService';

export function useGetPayLetterAvailablePaymentMethods() {
  return useQuery<GetPayLetterAvailablePaymentMethodsResponse, Error>(
    ['payLetterAvailablePaymentMethods'],
    getPayLetterAvailablePaymentMethods,
    {
      staleTime: 60 * 1000,
      cacheTime: 5 * 60 * 1000
    }
  );
}
